import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URLs } from '../../core/conf/urls';
@Injectable({
  providedIn: 'root'
})
export class MDSLookupService {

  constructor(private readonly httpClient: HttpClient) { }

  landUseTypes() {
    return this.httpClient.get(URLs.LAND_USE_TYPE_ENDPOINT) as Observable<any[]>;
  }

  mdsMaterialTypes() {
    return this.httpClient.get(URLs.MDS_MATERIAL_TYPE_ENDPOINT) as Observable<any[]>;
  }

  mdsMaterialSubTypes() {
    return this.httpClient.get(URLs.MDS_MATERIAL_SUB_TYPE_ENDPOINT) as Observable<any[]>;
  }

  mdsStorageTypes() {
    return this.httpClient.get(URLs.MDS_STORAGE_TYPE_ENDPOINT) as Observable<any[]>;
  }
}